import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: 'crm-three-panel-page-left-panel, [crmThreePanelPageLeftPanel]' })
export class ThreePanelPageLeftPanelDirective {
  @HostBinding('class') class = 'crm-three-panel-page-left-panel';
}
